export default __webpack_public_path__ + "static/media/weight-scale.f24425dc.png";